export const SCROLL_ANIMATION_DURATION_MS = 500;
export const SCROLL_SPY_THROTTLE = 500;
